module.exports = __webpack_public_path__ + "static/media/right-check.d0cda38a.svg";